import React from "react";
import {
  Card,
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Chip,
} from "@mui/material";
import {
  File,
  FileImage,
  FileText,
  UploadCloud,
  Edit,
  ExternalLink,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const AnnouncementCard = ({
  title,
  body, 
  status,
  _id,
  onEdit,
  onResend,
}) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    if (onEdit) {
      onEdit(_id);
    } else {
      navigate(`/edit-announcement/${_id}`);
    }
  };

  const handleResend = () => {
    if (onResend) {
      onResend(_id);
    }
  };

  const getStatusColor = (status) => {
    return status === "published" ? "#4CAF50" : "#FF9800";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        border: "2px solid #225B27",
        boxShadow: "none",
        p: 0,
        minHeight: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      {/* Edit Button */}
      {/* <IconButton
        onClick={handleEdit}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 1,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
        size="small"
      >
        <Edit size={16} />
      </IconButton> */}

      <Box px={2} pt={2}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={1}
        >
          <Typography
            variant="subtitle1"
            fontSize={14}
            fontWeight={700}
            sx={{ flex: 1, pr: 1 }}
          >
            {title || "No Title"}
          </Typography>
          <Chip
            label={status || "unpublished"}
            size="small"
            sx={{
              backgroundColor: getStatusColor(status),
              color: "white",
              fontSize: "10px",
              height: "20px",
            }}
          />
        </Box>

        <Typography variant="body2" sx={{ mb: 1, color: "#666" }}>
          {body || "No description available."}
        </Typography>

        {/* {attachment && (
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <FileText size={16} color="#4CAF50" />
                        <Typography variant="caption" color="primary" sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                            {attachment.split('/').pop()}
                        </Typography>
                    </Box>
                )}

                {createdAt && (
                    <Typography variant="caption" color="text.secondary">
                        {formatDate(createdAt)}
                    </Typography>
                )} */}
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        width={"100%"}
        gap={1}
        px={2}
        py={2}
      >
        {/* <Button
          color="#fff"
          sx={{
            color: "#fff",
            background:
              status === "published"
                ? "linear-gradient(90deg, #4CAF50, #2E7D32)"
                : "linear-gradient(90deg, #225B27, #053608)",
            borderRadius: "22px",
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "none",
            flex: 1,
          }}
        >
          {status === "published" ? "Published" : "Publish"}
        </Button> */}
        <Button
          variant="outlined"
          onClick={handleResend}
          sx={{
            color: "#225B27",
            borderColor: "#225B27",
            borderRadius: "22px",
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "none",
            flex: 1,
            "&:hover": {
              borderColor: "#225B27",
              backgroundColor: "rgba(34, 91, 39, 0.04)",
            },
          }}
        >
          Resend
        </Button>
      </Box>
    </Card>
  );
};

export default AnnouncementCard;
